import styled from 'styled-components';
import AllBookingSvg from '../../assets/mytrips/all-bookings.svg';

const AllBookingIcon = styled(AllBookingSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '3.2rem'};
  margin: ${props => props.margin};
`;

export default AllBookingIcon;
